import { pushToDataLayer } from '../../pushToDataLayer';
import { GTMEvent, GTMEventAttributes, GTMEventName } from '../../types';

export function recordingSettingsChangedInteractionEvent({
  updatedFields,
  fieldChanges,
}: {
  updatedFields: string[];
  fieldChanges?: Record<string, any>;
}) {
  const eventAttributes: GTMEventAttributes = {
    event: GTMEvent.COVIDEO_EVENT,
    event_name: GTMEventName.RECORDING_SETTINGS_CHANGED,
  };

  pushToDataLayer({
    ...eventAttributes,
    changed_fields: updatedFields,
    ...fieldChanges,
  });
}
